import { BRAND_TYPE } from "@faire/help-center-utils/consts/BRAND_TYPE";
import { RETAILER_TYPE } from "@faire/help-center-utils/consts/RETAILER_TYPE";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { ICreateTicketRequest } from "@faire/web-api--source/com/faire/vendor/zendesk/ICreateTicketRequest";
import { ZendeskViaChannelId } from "@faire/web-api--source/com/faire/vendor/zendesk/ZendeskViaChannelId";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import UAParser from "ua-parser-js";

import { ICallRequestForm } from "../../hooks/useInitializeCallRequestField";
import { getAllZenDeskTagsInArray } from "../../utils/zenDeskTags";

interface ICallRequestTicketPayloadRequest {
  values: ICallRequestForm;
  issueType: string;
}

export const getCallRequestTicketPayload = ({
  values,
  issueType,
}: ICallRequestTicketPayloadRequest) => {
  const retailer = getRetailer();
  const brand = getBrand();
  const ua = new UAParser(navigator.userAgent).getResult();
  const platform = ua.browser.name ?? "";
  const osVersion = `${ua.os.name ?? ""} ${ua.os.version ?? ""}`;
  const appVersion = ua.browser.version ?? "";
  const customerType = retailer ? RETAILER_TYPE : BRAND_TYPE;
  const businessName = retailer?.name ?? brand?.name;
  const customerBasedIn =
    retailer?.country ?? brand?.based_in ?? ISO3166Alpha3.USA;

  const phone_number = values.phone;

  const fallbackIssueType =
    issueType === "" ? "Phone Ticket" : `Issue type: ${issueType}`;
  const description =
    values.details === ""
      ? fallbackIssueType
      : `${values.details} - ${fallbackIssueType}`;
  const phoneTicketPayload = ICreateTicketRequest.build({
    tags: getAllZenDeskTagsInArray(
      customerBasedIn ?? "",
      customerType ?? "",
      issueType ?? "",
      "phone"
    ),
    email: values.email,
    user_name: values.name,
    name: businessName,
    phone_number,
    brand_order_token: values.brandOrderNumber,
    issue_type: issueType,
    description,
    platform: platform,
    os_version: osVersion,
    app_version: appVersion,
    via_channel_id: ZendeskViaChannelId.PHONE_CALL_INBOUND,
    order_token: values.orderToken,
  });

  return {
    phoneTicketPayload,
  };
};
